import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { FinanceEntityIdSchema } from '../finance/finance-entity-id.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'
import { ChargeIdSchema } from './charge-id.ts'
import { ChargeLineItemSchema } from './charge-line-item.ts'

export const ChargeSchema = z.object({
  chargeId: ChargeIdSchema,
  financeEntityId: FinanceEntityIdSchema,
  projectId: ProjectIdSchema,
  lineItems: z.array(ChargeLineItemSchema),
  actualInvoiceId: z.number().optional(),
})

export type Charge = ZodInfer<typeof ChargeSchema>
